var _style, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 335",
    width: 512,
    height: 335,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\ttspan { white-space:pre }\r\n\t\t.shp0 { fill: #ff4b55 } \r\n\t\t.shp1 { fill: #f5f5f5 } \r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M503.17 335.73L8.83 335.73C3.95 335.73 0 331.77 0 326.9L0 9.1C0 4.23 3.95 0.28 8.83 0.28L503.17 0.28C508.05 0.28 512 4.23 512 9.1L512 326.9C512 331.77 508.05 335.73 503.17 335.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp1",
    d: "M353.1 132.69L291.31 132.69L291.31 70.9C291.31 66.02 287.36 62.07 282.48 62.07L229.52 62.07C224.64 62.07 220.69 66.02 220.69 70.9L220.69 132.69L158.9 132.69C154.02 132.69 150.07 136.64 150.07 141.52L150.07 194.49C150.07 199.36 154.02 203.31 158.9 203.31L220.69 203.31L220.69 265.11C220.69 269.98 224.64 273.93 229.52 273.93L282.48 273.93C287.36 273.93 291.31 269.98 291.31 265.11L291.31 203.31L353.1 203.31C357.98 203.31 361.93 199.36 361.93 194.48L361.93 141.52C361.93 136.64 357.98 132.69 353.1 132.69Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwis);
export default __webpack_public_path__ + "static/media/swis.cf3e88a50029af9f50aae25f34b56ae3.svg";
export { ForwardRef as ReactComponent };